import { h } from 'preact';
import { configure } from '../../config';
import style from './style';
import { Text, MarkupText } from 'preact-i18n';

export function AboutOurAdsWidget({ clientDisplayName, links, adControls }) {
	let hostname = window.location.hostname;
	let intlFields = { hostname, ccpaLinks: links, clientDisplayName };

	return (

		<div class={style.aboutAds}>
			<div>
				<h1><Text id="aboutadsTitle" fields={intlFields} /></h1>
				<p><Text id="aboutadsDescription" fields={intlFields} /></p>
			</div>

			<div>
				<p>
					<strong><Text id="aboutadsWhoPlaced" fields={intlFields} /></strong>
				</p>
				<ul>
					<li><a href="/ccpa/partners"><Text id="aboutadsPlacedBy" fields={intlFields} /></a></li>
				</ul>
				<p />
				<hr />
				<p>
					<strong><Text id="aboutadsWhereLearn" fields={intlFields} /></strong>
				</p>
				<ul>
					<li><a href={links.privacy.url}><Text id="aboutadsPrivacyPractices" fields={intlFields} /></a></li>
				</ul>
				<p />
				<hr />
				<p>
					<strong><Text id="aboutAdsWhatChoices" fields={intlFields} /></strong>
					<br />
					<Text id="aboutAdsWhatChoicesDesc"fields={intlFields}  />
				</p>
				<ul>
					<li><MarkupText id="aboutAdsWhatChoicesItem1" fields={intlFields} /></li>
					<li><a href="http://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer"><Text id="aboutAdsWhatChoicesItem2" fields={intlFields} /></a></li>
					<li><a href="http://www.networkadvertising.org/understanding-online-advertising/what-are-my-options" target="_blank" rel="noopener noreferrer"><Text id="aboutAdsWhatChoicesItem3" fields={intlFields} /></a></li>
				</ul>
				<p />
			</div>
			<hr />
			<div>
				<h2><Text id="aboutAdsLearnMore" fields={intlFields} /></h2>
				<ul>
					<li><a href="http://www.networkadvertising.org/understanding-online-advertising/" target="_blank" rel="noopener noreferrer"><Text id="aboutAdsLearnMoreItem1" fields={intlFields} /></a></li>
				</ul>
				<br />
			</div>
		</div>


	);
}

export const AboutOurAds = (configure({
	adControls: 'privacyWidgetsConfig.aboutAds.adControls',
	clientDisplayName: 'clientDisplayName',
	links: 'privacyWidgetsConfig.ccpa.links'
})((props) =>  (
	<AboutOurAdsWidget {...props} />
)));
